import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataValueRisksState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataValueRisksReducer.staticDataValueRisksFeatureKey]
);

export const getStaticDataValueRisksFailure = createSelector(
  getStaticDataValueRisksState,
  staticDataCountriesReducer.fromStaticDataValueRisksReducer.getValueRisksError
);

export const getStaticDataValueRisksResponse = createSelector(
  getStaticDataValueRisksState,
  staticDataCountriesReducer.fromStaticDataValueRisksReducer.getValueRisks
);
